import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import BillingStore from '../../stores/billing'

@inject('websites', 'auth')
@observer
class Websites extends Component {
  billing = new BillingStore()

  componentDidMount() {
    this.billing.loadLicense()
  }

  _renderWebsite = website => (
    <tr key={website.id}>
      <td><Link to={`/website/${website.id}`}>{website.name}</Link></td>
      <td className="center">{website.leads_count}</td>
      <td className="center">{website.messages_count}</td>
      <td className="center">{website.hotsheets_count}</td>
      <td className={`center website-status-${website.status}`}>{website.status}</td>
    </tr>
  )

  renderWebsiteBilling() {
    const { license } = this.billing
    if (license) {
      if (license.additional_website_count > 0) {
        return (
          <ul>
            <li>Additional websites come at an additional cost. For current pricing, visit our <a href={'https://support.showcaseidx.com/hc/en-us/articles/360058589712-Multiple-Websites-and-How-to-Add-Another-Website-to-My-Account#h_01HDRX1DJDY8R2H92VWNAM5204'} target="_blank">Support Center</a></li>
          </ul>
        )
      }
    }
  }

  addNewWebsite = event => {
    event.preventDefault()

    const { websites } = this.props
    const { name } = this.form.elements

    const newWebsite = {
      name: name.value
    }

    websites.create(newWebsite).then(
      () => this.form.reset()
    ).then(
      () => this.billing.loadLicense()
    )
  }

  renderNewWebsiteForm() {
    if (this.props.auth.user.admin) {
      return (
        <form onSubmit={this.addNewWebsite} ref={form => this.form = form} style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
          <label htmlFor="name" style={{ width: '150px' }}>New Website</label>
          <input id="name" name="name" placeholder="Name" required style={{ padding: '6px 10px' }} />
          <button type="submit" style={{ width: '200px', margin: 0, marginLeft: '10px' }}>Create Website</button>
        </form>
      )
    }
  }

  render() {
    const { websites: { websites } } = this.props

    return (
      <div className="container centered padded websites">
        <div className="panel full padded">
          <h2 className="title">Websites</h2>

          {this.renderWebsiteBilling()}
          {this.renderNewWebsiteForm()}

          <table className="zebra">
            <thead>
              <tr>
                <th style={{textAlign: 'left', minWidth: 200}}>Name</th>
                <th>Leads</th>
                <th>Messages</th>
                <th>Hotsheets</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody className="padded">
              {Object.keys(websites).map(id => this._renderWebsite(websites[id]))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default Websites



// WEBPACK FOOTER //
// client/components/sections/Websites.js